import { gql } from '@apollo/client';

export const ATTRIBUTE_FRAGMENT = gql`
  fragment AttributeFragment on Attribute {
    _id
    allowedViewers
    allowedEditors
    isControlledByExternalAMSField
    isOnProfile
    label
    validationRules
    canCurrentUserEditValue
    validAllowedViewers
    ownerKind
    ... on FreeTextAttribute {
      freeTextValue: value
    }
    ... on MultiSelectAttribute {
      multiSelectValue: value
      options {
        id
        label
      }
    }
    ... on SingleSelectAttribute {
      singleSelectValue: value
      options {
        id
        label
      }
    }
  }
`;
